import Buy from './Components/Javascript/Buy';
import React from 'react'

export default function BuyPage() {
  return (
    <div>
      <Buy/>
    </div>
  )
}
